import { connect } from 'react-redux';
// eslint-disable-next-line import/no-named-as-default
import AddedStocks from './AddedStocks';
import { metricAddedStocks } from '../../../store/actions/metric';

const mapStateToProps = ({
  metricReducer,
  tabsReducer
}) => ({
  metricReducer,
  tabsReducer
});
const mapDispatchToProps = { metricAddedStocks };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddedStocks);
